import { render, staticRenderFns } from "./nonMCareCustomers.vue?vue&type=template&id=236fabdd&scoped=true"
import script from "./nonMCareCustomers.ts?vue&type=script&lang=ts&external"
export * from "./nonMCareCustomers.ts?vue&type=script&lang=ts&external"
import style0 from "./nonMCareCustomers.vue?vue&type=style&index=0&id=236fabdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fabdd",
  null
  
)

export default component.exports